import styled from '@emotion/styled';
import { theme } from '../../constants/theme';

const elevations = {
  none: 'none',
  sm: theme.shadows.sm,
  md: theme.shadows.md,
  lg: theme.shadows.lg,
  xl: theme.shadows.xl,
};

const paddings = {
  none: '0',
  sm: theme.spacing.sm,
  md: theme.spacing.md,
  lg: theme.spacing.lg,
};

export const StyledCard = styled.div`
  background-color: ${theme.colors.white};
  border-radius: ${theme.borderRadius.md};
  box-shadow: ${props => elevations[props.$elevation] || elevations.md};
  border: ${props => props.$bordered ? `1px solid ${theme.colors.gray[200]}` : 'none'};
  overflow: hidden;
  transition: ${theme.transitions.duration.normal} ${theme.transitions.timing.easeInOut};

  ${props => props.$hoverable && `
    cursor: pointer;
    &:hover {
      box-shadow: ${theme.shadows.xl};
      transform: translateY(-2px);
    }
  `}
`;

export const CardHeader = styled.div`
  padding: ${props => paddings[props.$padding] || paddings.md};
  border-bottom: 1px solid ${theme.colors.gray[200]};
  background-color: ${theme.colors.background.alt};
  font-weight: ${theme.typography.fontWeight.semibold};
  color: ${theme.colors.text.primary};
`;

export const CardBody = styled.div`
  padding: ${props => paddings[props.$padding] || paddings.md};
  color: ${theme.colors.text.primary};
  
  ${props => !props.$hasHeader && `
    border-top-left-radius: ${theme.borderRadius.md};
    border-top-right-radius: ${theme.borderRadius.md};
  `}
  
  ${props => !props.$hasFooter && `
    border-bottom-left-radius: ${theme.borderRadius.md};
    border-bottom-right-radius: ${theme.borderRadius.md};
  `}
`;

export const CardFooter = styled.div`
  padding: ${props => paddings[props.$padding] || paddings.md};
  border-top: 1px solid ${theme.colors.gray[200]};
  background-color: ${theme.colors.background.alt};
  display: flex;
  align-items: center;
  gap: ${theme.spacing.sm};
`;
